import { useState } from "react";
import CommonModal from "../../pages/modal/CommonModal";
import Image from "../form/Image";
import { useNavigate } from "react-router-dom";

const SignUpButton = ({ onSelectType }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleTypeSelect = (type) => {
    onSelectType(type);
    navigate("/signup", { state: type });
    handleClose();
  };

  return (
    <>
      <p className="signUpText mt-4 mb-4">
        Don't have an account? <span onClick={handleOpen}>Sign Up</span>
      </p>

      <CommonModal
        modelOpen={showModal}
        setModelOpen={handleClose}
        bodyContent={
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="text-center modal-center-heading">Sign Up</div>
              </div>
            </div>
            <div className="mb-4 mt-5">
              <div className="d-flex gap-3 flex-column m-auto w-50">
                <button
                  type="button"
                  className={`selectionType-btn mb-4`}
                  onClick={() => handleTypeSelect("Athlete")}
                >
                  Athlete
                  <span className="right-arrow">
                    <Image src="images/leftarrow.svg"></Image>
                  </span>
                </button>
                <button
                  type="button"
                  className={`selectionType-btn mb-4`}
                  onClick={() => handleTypeSelect("Contractor")}
                >
                  Service Provider
                  <span className="right-arrow">
                    <Image src="images/leftarrow.svg"></Image>
                  </span>
                </button>
              </div>
            </div>
          </form>
        }
      />
    </>
  );
};

export default SignUpButton;
